// fetchBaseQuery.js
import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { setSessionExpired } from "@/redux/SessionSlice";

export const baseQuery = async (args, api, extraOptions) => {
  const rawResult = await fetchBaseQuery({
    baseUrl: import.meta.env.VITE_BASE_API_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = getState()?.auth?.token;
      const localToken = localStorage.getItem("userToken");
      if (token || localToken) headers.set("Authorization", `Bearer ${token || localToken}`);

      headers.set("X-Request-Id", crypto.randomUUID());

      return headers;
    },
  })(args, api, extraOptions);

  // Use api.dispatch instead of store.dispatch
  if (rawResult.error?.status === 401 || rawResult.error?.status === 403) {
    api.dispatch(setSessionExpired());
  }
  // else{
  //    api.dispatch(setSessionExpired());
  // }

  return rawResult;
};

